/**
 * @summary Sets Webpack public path.
 */

/* eslint-disable camelcase, no-unused-vars */
/* global __webpack_public_path__ */

__webpack_public_path__ = wp_data.path;



// WEBPACK FOOTER //
// ./src/js/public-path.js